import * as React from 'react';
import { connect } from 'react-redux';
import { setTimeShow, setStep } from '../../../actions/claimSubmitActions';
import FnolStep1Sub1 from './FnolStep1Sub1Overview';
import FnolStep1Sub2 from './FnolStep1Sub2InfoReady';
import FnolStep1Sub3 from './FnolStep1Sub3';
import FnolStep1Sub4 from './FnolStep1Sub4ClaimInfo';
import Disclaimer from '../Glass/Disclaimer';
import { CLAIM_TYPE_CELLPHONE, CLAIM_TYPE_GLASS } from '../../../constants/constants';
import CellphoneClaimsDetails from '../../Claims/Cellphone/CellphoneClaimsDetails';
import IncidentInfo from '../FollowUpSteps/IncidentInfo';
import RoadSurface from '../FollowUpSteps/RoadSurface';


class FnolStep1 extends React.Component<any, any>  {
    constructor(props) {
        super(props);
    }

    public render() {
        if (this.props.claimSubmit.selectedClaimStep.subStep === 1 && this.props.claimSubmit.followUp) {
            if (this.props.claimSubmit.followUpType == 'multiple-collision') {
                return <IncidentInfo />
            }
            if (this.props.claimSubmit.followUpType == 'pedestrian' || this.props.claimSubmit.followUpType == 'pothole') {
                return <RoadSurface />
            }
        }
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 1 && !this.props.claimSubmit.showDisclaimer)
            return <FnolStep1Sub1 />
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 1 && this.props.claimSubmit.showDisclaimer)
            return <Disclaimer />
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 2 && this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE)
            return <CellphoneClaimsDetails />
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 2 && this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS)
            return <FnolStep1Sub2 />
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 3)
            return <FnolStep1Sub3 />
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 4 && this.props.claimSubmit.claimType !== CLAIM_TYPE_CELLPHONE || (this.props.claimSubmit.selectedClaimStep.subStep === 2 && this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS))
            return <FnolStep1Sub4 />
        else if (this.props.claimSubmit.selectedClaimStep.subStep === 4 && this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE)
            return <CellphoneClaimsDetails />
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep1)